export default __webpack_public_path__ + "static/media/team92.769f45e6.JPG";